import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/lib/jenkins/workspace/community-deploy/frontend/app/registration/_components/RegistrationContent.tsx");
